/**
 * API configuration based on environment
 */
const apiConfig = {
  // Base API URL that changes based on environment
  baseUrl: process.env.NODE_ENV === 'production' 
    ? 'https://node-api.imuslimlife.com/v1'
    : 'http://localhost:3000/v1',
  
  // Request timeout in milliseconds
  timeout: 10000,
  
  // Additional configuration
  headers: {
    'Content-Type': 'application/json'
  }
};

export default apiConfig;